import React from 'react';
import {result} from 'lodash';
import FORMULAS from '../../../../utils/fomulas';
import BasePipelineStepComponent from '../base_pipeline_step';

export default class EditColumnStepComponent extends BasePipelineStepComponent {
    action_present = 'Edit Column';
    action_past = 'Edited Column';
    icon = 'transformations-edit';

    formulaSelect = null;
    amountInput = null;

    constructor(props) {
        super(props);

        Object.assign(this.state, {
            amount: props.step.getArg('amount'),
        });
    }

    updateStep(ev, step) {
        const {value} = ev.target;
        if (ev.target === this.formulaSelect) {
            step.formula = FORMULAS[value];
        }
        if (ev.target === this.amountInput) {
            step.setArg('amount', parseFloat(value));
        }
        this.setState({amount: value});
    }

    renderHeader() {
        const {results} = this.state;
        return (
            <div className="pipeline-step-text pipeline-highlight">
                Edit Column <span className="column-highlight">{results.before}</span>
            </div>
        );
    }

    renderForm() {
        const {tempStep, amount} = this.state;
        return (
            <>
                <form onSubmit={this.onSave}>
                    <label className="label">
                        Formula Type
                    </label>
                    <select
                        className="select-field w-select"
                        value={result(tempStep.formula, 'name', '')}
                        onChange={this.onChange}
                        ref={(input) => { this.formulaSelect = input; }}
                    >
                        {Object.values(FORMULAS).map(formula => (
                            <option
                                key={formula.name}
                                value={formula.name}
                            >
                                {formula.label}
                            </option>
                        ))}
                    </select>
                    {result(tempStep.formula, 'needsArgs') && (
                        <>
                            <label className="label">
                                Amount
                            </label>
                            <input
                                type="text"
                                className="input w-input"
                                value={amount}
                                onChange={this.onChange}
                                ref={(input) => { this.amountInput = input; }}
                                placeholder="amount"
                            />
                        </>
                    )}
                </form>
                <div className="pipeline-step-form-help-text">
                    Use this step to edit an existing column. In this prototype
                    only simple math operations and Running Total are available.
                </div>
            </>
        );
    }

    renderValue() {
        const {results} = this.state;
        const {step} = this.props;
        return (
            <div className="pipeline-step-text pipeline-highlight">
                Edited Column <span className="column-highlight">{results.before}</span> <span className="column-value">{step.getDisplay()}</span>
            </div>
        );
    }
}
